export default {
  namespaced: true,
  state: {
    autoChangeEndDate: false,
    payload: {
      start_date: '',
      end_date: '',
      measures: [],
      rows_per_page: 10,
      page_nr: 1,
      sort_by: '',
      sort_direction: 'ASC',
      reachCriteria: 15,
      columns: [],
      title_search: '',
      site_id: [],
      queryKeys: [],
    },
  },
  getters: {
    siteReachApiBody: state => state.payload,
  },
  mutations: {
    updateMeasures(state, newMeasures) {
      state.payload.measures = JSON.parse(JSON.stringify(newMeasures));
    },
    updateQueryKeys(state, newQueryKeys) {
      state.payload.queryKeys = newQueryKeys;
    },
    emptyQueryKeys(state) {
      state.payload.queryKeys = [];
    },
    updateStartDate(state, newStartDate) {
      state.payload.start_date = newStartDate;
    },
    updateEndDate(state, newEndDate) {
      state.payload.end_date = newEndDate;
    },
    updateMeasureTypeSite(state, newMeasureType) {
      state.payload.measures.forEach(measure => {
        measure.measure_type = newMeasureType;
      });
    },
    updateMinViewingTimeSite(state, newMinViewingTime) {
      state.payload.reachCriteria = newMinViewingTime;
      state.payload.measures.forEach(measure => {
        measure.min_viewing_time = newMinViewingTime;
      });
    },
    updateAutoChangeEndDate(state, newAutoChangeEndDate) {
      state.autoChangeEndDate = newAutoChangeEndDate;
    },
  },
};
